// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"styles_loaderWrapper__GHI7z"};